export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";